export const phoneRegex = /8\d{3}\d{3}\d{2}\d{2}/g;
